export class SettingsButton {
    font = null
    background = null
    border = null
    shadow = null
    title = null
    titleAlternative = null
    titleOneQuestion = null
    type = null
    margin = null
    padding = null
    alert = null
    isShowDesignSettings = false
    hasAlternative = false

    constructor({
        type = "",
        background = "#5E7BE0",
        font = {
            family: "Inter",
            size: 16,
            height: 160,
            weight: "normal",
            color: "#fff"
        },
        border = {
            style: "solid",
            width: [0, 0, 0, 0],
            color: "transparent",
            radius: [8, 8, 8, 8]
        },
        shadow = {
            blur: 10,
            color: "#809EBF26",
            horizontal: 0,
            vertical: 4
        },
        title = "",
        hasAlternative = false,
        hasOneQuestion = false,
        titleOneQuestion = "",
        titleAlternative = "",
        margin = [0, 0, 0, 0],
        padding = [10, 20, 10, 20],
        alert = ""
    }) {
        this.font = font
        this.background = background
        this.shadow = shadow
        this.border = border
        this.title = title
        this.titleAlternative = titleAlternative
        this.titleOneQuestion = titleOneQuestion
        this.type = type
        this.margin = margin
        this.padding = padding
        this.alert = alert
        this.hasAlternative = hasAlternative
        this.hasOneQuestion = hasOneQuestion
    }

    toggleDesignSettings() {
        this.isShowDesignSettings = !this.isShowDesignSettings
    }
}

export const ButtonTypes = {
    NEXT: "next",
    ANSWER: "answer",
    BACK: "back",
    FINISH: "finish",
    CHECK: "check",
    CLEAR: "clear"
}
